import React, { useEffect, useState } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { Form, Message } from 'semantic-ui-react';
import '../App.css';
import './cookoff.css';
import LoadingScreen from './LoadingScreen';
import { storageUtils } from '../utils/localStorage';
import { assignGroup, isGroup, preloadFirestore } from '../utils/groups';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_LOADING_MS = 1500;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Older pages stored the string "undefined" when the name was left blank.
const savedName = () => {
  const name = storageUtils.getUserName();
  return name && name !== 'undefined' ? name : '';
};

export default function FindMyGroup() {
  const history = useHistory();
  const { search } = useLocation();
  const [savedGroup] = useState(
    () => storageUtils.getUser() && storageUtils.getActiveGroup()
  );
  const [name, setName] = useState(savedName);
  const [email, setEmail] = useState(() => storageUtils.getUser() || '');
  const [error, setError] = useState('');
  const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Find My Group · The Great Bowls Of Fire';
    preloadFirestore();

    return () => {
      document.title = previousTitle;
    };
  }, []);

  if (isGroup(savedGroup)) {
    return <Redirect to={{ pathname: `/${savedGroup}`, search }} />;
  }

  const findGroup = async () => {
    if (isAssigning) return;

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    if (!trimmedName) {
      setError('Please enter your full name.');
      return;
    }
    if (!EMAIL_PATTERN.test(trimmedEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    setError('');
    setIsAssigning(true);
    storageUtils.setUser(trimmedEmail);
    storageUtils.setUserName(trimmedName);

    const [group] = await Promise.all([
      assignGroup({ email: trimmedEmail, name: trimmedName }),
      wait(MIN_LOADING_MS),
    ]);
    storageUtils.setGroup(group);
    history.replace({ pathname: `/${group}`, search });
  };

  return (
    <>
      <LoadingScreen
        isVisible={isAssigning}
        subtitle="Finding your tasting group..."
      />

      <main className="App-header cookoff-page">
        <div className="content">
          <div className="top-half"></div>

          <div className="cookoff-badge-wrap">
            <img
              className="cookoff-badge"
              src={`${process.env.PUBLIC_URL}/hot-pepper.png`}
              alt=""
              width="240"
              height="240"
            />
          </div>

          <div className="cookoff-intro">
            <h1 id="fmg-title" className="cookoff-title">
              Welcome to JJ's Chili Cookoff!
            </h1>
          </div>

          <section className="cookoff-login" aria-labelledby="fmg-title">
            <p className="cookoff-login-prompt">
              Enter your name and email to get started.
            </p>

            <div className="login-form-container cookoff-form">
              <Form onSubmit={findGroup} error={Boolean(error)} noValidate>
                <Form.Field>
                  <label htmlFor="fmg-name">Full Name</label>
                  <input
                    id="fmg-name"
                    placeholder="Full Name"
                    autoComplete="name"
                    maxLength={100}
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="fmg-email">Email</label>
                  <input
                    id="fmg-email"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    maxLength={254}
                    placeholder="BiebsWasHere@gmail.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </Form.Field>

                <Message error role="alert" className="cookoff-notice">
                  {error}
                </Message>

                <div className="cookoff-actions">
                  <button
                    className="email-btn"
                    type="submit"
                    disabled={isAssigning}
                  >
                    Get Started
                  </button>
                </div>
              </Form>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
